exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".LoginPage{display:flex;flex-grow:1;align-items:center;justify-content:center;height:100%;overflow:hidden}.LoginPage .LoginForm{margin:auto;background-color:#fff;border-radius:8px;padding:10px}.LoginPage .LoginForm input{display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/routes/create-account/style.scss
// module id = 284
// module chunks = 0